module.exports = __webpack_public_path__ + "img/learn-task2.11b61670.png";